import type { Bono, ComparisonBlock, ComparisonRow, FaqItem, Testimonio, Tomo } from '../types/content';

export const testimoniosIniciales: Testimonio[] = [
  {
    quote:
      'Organicé todo mi año de telas en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
    name: 'Florencia M.',
    city: 'Buenos Aires',
    role: 'Profe de Telas en Estudio Propio'
  },
  {
    quote:
      'Las clases con progresión real por nivel cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de irse.',
    name: 'Camila R.',
    city: 'Rosario',
    role: 'Profe de Telas en Centro Deportivo'
  },
  {
    quote:
      'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mezclado.',
    name: 'Valentina F.',
    city: 'Córdoba',
    role: 'Profe de Telas Grupal e Individual'
  }
];

export const problemas: string[] = [
  'Llegás a la clase sin saber exactamente qué figura vas a dar hoy.',
  'Tus alumnas no progresan porque no tenés una secuencia clara de nivel a nivel.',
  'El 40% de tus alumnas abandona antes de los 3 meses y no sabés cómo prevenirlo.',
  'Siempre las mismas 10 figuras de siempre porque no tenés más material listo.',
  'No podés justificar un aumento de precio porque no tenés un sistema profesional visible.',
  'Correcciones improvisadas, sin un método claro que te respalde.',
  'Alumnas de distintos niveles juntas y la clase se convierte en un caos.',
  'Fin de mes y las alumnas se van sin avisar porque la comunicación es inconsistente.'
];

export const tomos: Tomo[] = [
  {
    numero: 'TOMO 1',
    icono: '📖',
    titulo: 'Fundamentos del Docente de Telas',
    etiqueta: 'TEORÍA ESENCIAL',
    descripcion: 'De alumna a profe: todo lo que necesitás saber antes de dar tu primera clase',
    descripcionCompleta: 'Mentalidad docente, anatomía básica aplicada a telas, tipos de telas y montaje seguro, normas de seguridad esenciales, cómo leer el cuerpo del alumno, errores más comunes del docente principiante y checklist completo del profe listo para enseñar.'
  },
  {
    numero: 'TOMO 2',
    icono: '🟢',
    titulo: 'Planificación de Clases Nivel Básico',
    etiqueta: '15 CLASES LISTAS',
    descripcion: 'Cómo armar clases completas, progresivas y seguras desde cero',
    descripcionCompleta: 'Estructura de una clase de telas completa, progresión didáctica del suelo al aire, 15 clases listas para usar, cómo adaptar la clase según el grupo y plantilla editable de planificación semanal.'
  },
  {
    numero: 'TOMO 3',
    icono: '🟡',
    titulo: 'Planificación de Clases Nivel Intermedio',
    etiqueta: '15 CLASES LISTAS',
    descripcion: 'Elevá tus clases: figuras más complejas con metodología clara',
    descripcionCompleta: 'Criterios para pasar un alumno de nivel, descripción técnica de figuras intermedias, 15 clases completas, cómo combinar figuras en secuencias, corrección postural y verbal efectiva y registro de progreso del alumno.'
  },
  {
    numero: 'TOMO 4',
    icono: '🔴',
    titulo: 'Planificación de Clases Nivel Avanzado',
    etiqueta: '15 CLASES LISTAS',
    descripcion: 'Diseñá experiencias de alto vuelo para alumnos exigentes',
    descripcionCompleta: 'El alumno avanzado y sus necesidades, figuras avanzadas y combinaciones coreográficas, 15 clases completas, introducción a la coreografía en telas, trabajo de fuerza y flexibilidad específica y rúbrica de evaluación de nivel.'
  },
  {
    numero: 'TOMO 5',
    icono: '💼',
    titulo: 'Gestión y Organización del Docente',
    etiqueta: 'PLANTILLAS INCLUIDAS',
    descripcion: 'Administrá tu espacio, tus alumnos y tu tiempo como una profe profesional',
    descripcionCompleta: 'Sistema de niveles y grupos, fichas de inscripción y consentimiento informado, cómo cobrar y fijar precios, cómo manejar alumnos con lesiones, organización mensual de contenidos y kit de formularios listos para usar.'
  },
  {
    numero: 'TOMO 6',
    icono: '📱',
    titulo: 'Marketing para Profe de Telas',
    etiqueta: 'PLAN DE 30 DÍAS',
    descripcion: 'Llenate de alumnos sin depender del boca a boca',
    descripcionCompleta: 'Marca personal como profe de telas, qué publicar en Instagram para atraer alumnos, cómo usar reels y stories, estrategias para conseguir tus primeros 20 alumnos, cómo fidelizar y reducir la rotación y calendario de contenido mensual.'
  },
  {
    numero: 'TOMO 7',
    icono: '📅',
    titulo: 'Programa Anual de Telas',
    etiqueta: '12 MESES PLANIFICADOS',
    descripcion: 'Tu año entero de clases organizado, mes por mes',
    descripcionCompleta: 'Objetivos mensuales definidos por nivel, progresión técnica organizada mes a mes, planificación de evaluaciones y muestras, cronograma de clases especiales y períodos de repaso, seguimiento anual del progreso de cada alumna y calendarios y registros listos para usar.'
  }
];

export const incluyeCadaTomo: string[] = [
  'Planificación lista para usar desde el primer día.',
  'Clases con objetivo, desarrollo y cierre.',
  'Indicaciones técnicas listas para usar en clase.',
  'Variaciones Nivel 1, Nivel 2 y Nivel 3 por figura.',
  'Checklist previo y durante la clase.',
  'Planillas de seguimiento de alumnas.',
  'Adaptaciones para grupos heterogéneos.',
  '100% adaptado a la realidad de las profes de telas de Argentina.'
];

export const bonos: Bono[] = [
  {
    numero: 'BONO 1',
    icono: '🔥',
    titulo: 'Banco de Calentamientos',
    etiqueta: 'GRATIS',
    descripcionCompleta: '30 calentamientos específicos para telas, listos para usar. Organizados por objetivo: movilidad, fuerza y coordinación. Con variantes para distintas edades y niveles. Versión corta de 10 minutos y versión completa de 20 minutos. Nunca más empezar la clase sin saber cómo arrancar.'
  },
  {
    numero: 'BONO 2',
    icono: '📚',
    titulo: 'Diccionario de Figuras de Telas',
    etiqueta: 'GRATIS',
    descripcionCompleta: 'Nombre técnico, descripción y puntos clave de 60 figuras organizadas por nivel. Descripción de agarre, posición corporal y errores frecuentes de cada figura. Ideal para estandarizar el vocabulario en clase y hablar con precisión profesional.'
  },
  {
    numero: 'BONO 3',
    icono: '🗣️',
    titulo: 'Guía de Corrección Verbal y Física',
    etiqueta: 'GRATIS',
    descripcionCompleta: 'Qué decir y cómo asistir para corregir sin lastimar ni bloquear al alumno. Frases exactas para corrección verbal, técnica de contacto seguro para asistir figuras y cómo dar feedback positivo que motive y retenga.'
  },
  {
    numero: 'BONO 4',
    icono: '🛡️',
    titulo: 'Protocolos de Seguridad y Primeros Auxilios',
    etiqueta: 'GRATIS',
    descripcionCompleta: 'Actuá rápido y bien ante cualquier situación en clase. Protocolo ante caídas, mareos y calambres, cómo hacer revisión de telas y puntos de anclaje y qué hacer antes, durante y después de un incidente. La tranquilidad que todo profe necesita.'
  },
  {
    numero: 'BONO 5',
    icono: '🎭',
    titulo: 'Clases Especiales y Temáticas',
    etiqueta: 'GRATIS',
    descripcionCompleta: '8 clases temáticas completas listas para usar: Halloween, verano, show, clases abiertas y más. Cómo incorporar música y ambientación para crear experiencias memorables. Ideas para eventos especiales que fidelizan alumnos.'
  }
];

export const bloquesComparativos: ComparisonBlock[] = [
  {
    titulo: 'Sistema de Planificación por Niveles',
    frase: 'Cada clase tiene un objetivo y cada nivel tiene una progresión.',
    columnaSin: 'SIN UN SISTEMA',
    columnaCon: 'CON PROFES DE TELAS RESUELTO',
    filas: [
      { sin: 'Improvisás la clase a último momento', con: 'Tenés clases completas listas para usar.' },
      { sin: 'Repetís siempre las mismas figuras', con: 'Contás con variedad y progresión real.' },
      { sin: 'Los niveles mezclados generan caos', con: 'Adaptás cada ejercicio a tres niveles.' },
      { sin: 'No sabés cuándo avanzar', con: 'Seguís una secuencia clara de aprendizaje.' },
      { sin: 'Planificás durante horas', con: 'Resolución semanal en pocos minutos.' }
    ]
  },
  {
    titulo: 'Programa Anual de Telas: 12 Meses Planificados',
    frase: 'Tu año entero de clases organizado, mes por mes.',
    columnaSin: 'SIN PROGRAMA ANUAL',
    columnaCon: 'CON EL TOMO 7',
    filas: [
      { sin: 'No sabés qué enseñar cada mes', con: 'Objetivos mensuales definidos por nivel.' },
      { sin: 'La progresión es inconsistente', con: 'Progresión técnica mes a mes.' },
      { sin: 'No sabés cuándo evaluar', con: 'Instancias de evaluación planificadas.' },
      { sin: 'El recital se convierte en un caos', con: 'Cronograma de muestras y clases abiertas.' },
      { sin: 'Todo queda en papeles sueltos', con: 'Calendarios y registros listos para completar.' }
    ]
  }
];

export const testimoniosCompletos: Testimonio[] = [
  {
    quote:
      'Compré un domingo a la noche. El lunes entré al espacio con el plan exacto de la clase. El Tomo 2 es exactamente lo que necesitaba para mis grupos de principiantes. Nunca más improviso.',
    name: 'Florencia M.',
    city: 'Buenos Aires',
    role: 'Profe de Telas en Estudio Propio'
  },
  {
    quote:
      'El Tomo 4, el de nivel avanzado, me cambió todo. El primer mes, alumnas que llevaban meses estancadas mejoraron visiblemente su técnica. El Diccionario de Figuras me da la tranquilidad que antes no tenía.',
    name: 'Camila R.',
    city: 'Rosario',
    role: 'Profe en Centro Deportivo'
  },
  {
    quote:
      'El sistema de progresión es único. Son clases listas para usar en cada nivel, con indicaciones técnicas explicadas paso a paso. Antes tardaba horas armando una secuencia. Ahora abro el PDF y en minutos tengo todo listo.',
    name: 'Valentina F.',
    city: 'Córdoba',
    role: 'Profe de Telas Grupal e Individual'
  },
  {
    quote:
      'La Guía de Corrección del Bono 3 eliminó mi inseguridad al corregir. Ahora sé exactamente qué decir y cómo asistir. Mis alumnas sienten la diferencia y mis clases tienen otro nivel de profesionalismo.',
    name: 'Luciana P.',
    city: 'Tucumán',
    role: 'Profe Particular y en Gimnasio'
  },
  {
    quote:
      'La tasa de abandono de mis grupos bajó muchísimo. Solo aplicando el sistema de progresión y la variedad de los 7 tomos. Las alumnas ahora quieren venir porque siempre hay algo nuevo.',
    name: 'Marcela G.',
    city: 'Mendoza',
    role: 'Profe de Telas Online y Presencial'
  },
  {
    quote:
      'El Tomo 6 de marketing me salvó de seguir dependiendo del boca a boca. Ahora tengo un sistema para atraer alumnas. Mi espacio está lleno por primera vez en dos años.',
    name: 'Laura V.',
    city: 'Santa Fe',
    role: 'Profe de Telas en Estudio Propio'
  },
  {
    quote:
      'El Programa Anual del Tomo 7 me cambió la cabeza. Ahora tengo los 12 meses organizados y sé exactamente qué objetivo trabajar con cada grupo. Dejé de vivir apagando incendios.',
    name: 'Ana R.',
    city: 'Salta',
    role: 'Profe en Centro de Actividades Aéreas'
  }
];

export const faqs: FaqItem[] = [
  {
    pregunta: '¿Cómo recibo Profes de Telas Resuelto después de comprar?',
    respuesta:
      'Una vez acreditado el pago, recibís por correo electrónico las instrucciones para acceder a todo el contenido digital. El acceso es inmediato.'
  },
  {
    pregunta: '¿Sirve para profes con poca experiencia o solo para las avanzadas?',
    respuesta:
      'Sirve para todos los niveles de experiencia docente. El Tomo 1 comienza desde los fundamentos y los tomos siguientes avanzan progresivamente. Si sos nueva, empezás por el principio. Si ya tenés experiencia, vas directamente al contenido que necesitás.'
  },
  {
    pregunta: '¿Es editable? ¿Puedo adaptarlo a mis clases?',
    respuesta:
      'El material principal se entrega en formato PDF. Podés imprimirlo, consultarlo desde cualquier dispositivo y adaptar las propuestas a las necesidades de tus grupos.'
  },
  {
    pregunta: '¿Los 5 bonos están incluidos?',
    respuesta:
      'Sí. La única oferta incluye los 7 tomos y los 5 bonos completos, sin pagos adicionales.'
  },
  {
    pregunta: '¿Sirve si doy clases individuales o solamente para grupos?',
    respuesta:
      'Sirve para ambas modalidades. Las propuestas se pueden utilizar tanto en clases individuales como grupales.'
  },
  {
    pregunta: '¿Sirve si tengo alumnas de distintos niveles al mismo tiempo?',
    respuesta:
      'Sí. El sistema incluye variaciones para nivel básico, intermedio y avanzado, para que puedas adaptar una misma propuesta a grupos heterogéneos.'
  },
  {
    pregunta: '¿Qué diferencia tiene con otros materiales de telas?',
    respuesta:
      'No es una lista de figuras sueltas. Es un sistema completo que integra fundamentos, planificación por niveles, gestión, seguridad, comunicación, marketing y un programa anual.'
  },
  {
    pregunta: '¿El Programa Anual de 12 meses está incluido?',
    respuesta:
      'Sí. Forma parte del Tomo 7 y está incluido dentro de la única oferta, junto con los demás tomos y bonos.'
  },
  {
    pregunta: '¿Tiene garantía real?',
    respuesta:
      'Sí. Tenés 7 días para revisar el material. Si no es lo que esperabas, podés solicitar la devolución del 100%.'
  }
];

export const transformacion: ComparisonRow[] = [
  {
    sin: '⏰ 3–5 horas semanales planificando desde cero',
    con: '✅ 10 minutos por semana. El resto es enseñar.'
  },
  {
    sin: '😓 Siempre las mismas figuras y alumnas aburridas',
    con: '✅ Más de 60 clases para que siempre haya algo nuevo.'
  },
  {
    sin: '💸 Alumnas que abandonan sin saber por qué',
    con: '✅ Sistema de progresión que mejora la retención.'
  },
  {
    sin: '📋 Sin progresión clara de nivel a nivel',
    con: '✅ 7 tomos con progresión anual.'
  },
  {
    sin: '😨 Dificultad inesperada y corrección improvisada',
    con: '✅ Protocolos y herramientas para actuar con confianza.'
  },
  {
    sin: '👥 Niveles mezclados y caos en clase',
    con: '✅ Variaciones por nivel para que todas puedan avanzar.'
  },
  {
    sin: '📱 Comunicación inconsistente',
    con: '✅ Guía de marketing y planificación de contenido.'
  },
  {
    sin: '💼 Sin identidad profesional visible',
    con: '✅ Un sistema que respalda y profesionaliza tu trabajo.'
  }
];
